import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { SuppliesCollectionSchema } from "./collection";

export const getSuppliesCollections = unaryRpc({
  name: "getSuppliesCollections" as const,
  input: z.object({}),
  output: z.object({
    collections: z.array(
      SuppliesCollectionSchema.and(
        z.object({ matchingProductFamilyCount: z.number() }),
      ),
    ),
  }),
});
